﻿import { ICenterAddress } from './center-address';
import { IContact } from './contact';

export interface ILogistics {
    recipientId: number;
    recipientAlias: string;
    recipientCenter: string;
    recipientCenterTimezone: string;
    recipientCenterId: number;
    recipientCenterAddress: ICenterAddress;
    recipientCoordinator: IContact;
    recipientSurgeon: IContact;
    donorId: number;
    donorAlias: string;
    donorUnosId: string;
    donorCenter: string;
    donorCenterTimezone: string;
    donorCenterId: number;
    donorCenterAddress: ICenterAddress;
    donorCoordinator: IContact;
    donorSurgeon: IContact;
    isRemoteDonation: boolean;
    rdnCenterId: number;
    rdnCenterAlias: string;
    rdnCenterTimezone: string;
    rdnCenterAddress: ICenterAddress;
    logisticsProvider: string;
    logisticsProviderName: string;
    logisticsProviderPhone: string;
    kidneyPickupDateTime: string;
    kidneyPickupDateTimeBackup: string;
    kidneyPickupDateTimeActual: string;
    kidneyPickupDateTimeTz: string;
    pickupGroundMiles: string;
    pickupGroundMilesBackup: string;
    pickupGroundMilesActual: string;
    dropoffGroundMiles: string;
    dropoffGroundMilesBackup: string;
    dropoffGroundMilesActual: string;
    kidneyArrivalDateTime: string;
    kidneyArrivalDateTimeBackup: string;
    kidneyArrivalDateTimeActual: string;
    kidneyArrivalDateTimeTz: string;
    flightRouteOrGround: string;
    flightRouteOrGroundBackup: string;
    flightRouteOrGroundActual: string;
    transportMethod: string;
    transportMethodDescription: string,
    transportMethodBackup: string;
    transportMethodBackupDescription: string;
    transportMethodActual: string;
    transportMethodActualDescription: string;
    transportCost: string;
    transportCostBackup: string;
    transportCostActual: string;
    courierTransportCost: string;
    courierTransportCostBackup: string;
    flightCarrierAndNumber: string;
    flightCarrierAndNumberBackup: string;
    flightCarrierAndNumberActual: string;
    flightDepartureTime: string;
    flightDepartureTimeTz: string;
    flightDepartureTimeBackup: string;
    flightDepartureTimeBackupTz: string;
    flightDepartureTimeActual: string;
    flightDepartureTimeActualTz: string;
    flightArrivalTime: string;
    flightArrivalTimeTz: string;
    flightArrivalTimeBackup: string;
    flightArrivalTimeBackupTz: string;
    flightArrivalTimeActual: string;
    flightArrivalTimeActualTz: string;
    leg2DepartureTime: string;
    leg2DepartureTimeTz: string;
    leg2DepartureTimeActual: string;
    leg2DepartureTimeActualTz: string;
    leg2DepartureTimeBackup: string;
    leg2DepartureTimeBackupTz: string;
    leg2ArrivalTime: string;
    leg2ArrivalTimeTz: string;
    leg2ArrivalTimeActual: string;
    leg2ArrivalTimeActualTz: string;
    leg2ArrivalTimeBackup: string;
    leg2ArrivalTimeBackupTz: string;
    tenderedToAirlineActual: string;
    tenderedToAirlineActualTz: string;
    recoveredFromAirlineActual: string;
    recoveredFromAirlineActualTz: string;
    deliveryLocation: string;
    deliveredTo: string;
    activeLogisticsPlan: string;
    jobNumber: string;
    chainId: number;
    clusterNumber: number;
    position: string;
    earliestPickupTime: string;
    latestDropoffTime: string;
    opo: string;
    targetSurgeryDate: string;
    targetPickupTime: string;
    kidneyArrivalDate: string;
    flightArrivalTimeOnly: string;
    kidneyArrivalTime: string;
    logisticsOptionStatus: number;
    logisticsOptionDeadline: string;
    logisticsPlanNotes: string;
    swapManager: string;
    gpsNumber: string;
    gpsLink: string;
    whichDonorKidney: string;
    tubes: string[];
    recipientSurgeons: IContact[];
    donorSurgeons: IContact[];
}
